import ApiService from './api.service.js';

export default {
  getClientUsers(clientId) {
    const today = new Date().toISOString();
    const $filter = `startDate le ${today} and endDate ge ${today}`;
    return ApiService.get(
      `/subscriptions/?clientId=${clientId}&$filter=${$filter}&type=users&active=true&sort=-startDate`
    );
  },
  getClientCredits(clientId) {
    return ApiService.get(`/subscriptions/${clientId}/resume`);
  }
};
